// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'


function calculateForm3(){

  var hoogte = $('.acf-field').find("[data-name='form3_hoogte']").find(':input').val();
  var breedte = $('.acf-field').find("[data-name='form3_breedte']").find(':input').val();
  var aantal_regels = $('.acf-field').find("[data-name='form3_regels']").find(':input').val();
  var kwaliteit = $('.acf-field').find("[data-name='form3_kwaliteit']").find('label.selected > input[type="radio"]').val();

  var stuwdruk = $('.acf-field').find("[data-name='form3_stuwdruk']").find(':input').val();
  var zone = $('.acf-field').find("[data-name='form3_zone']").find('label.selected > input[type="radio"]').val();

  var overspanning = $('.acf-field').find("[data-name='form3_overspanning']").find(':input').val();
  var belastinglinksonder = $('.acf-field').find("[data-name='form3_belastinglinksonder']").find(':input').val();
  var belastingrechtsboven = $('.acf-field').find("[data-name='form3_belastingrechtsboven']").find(':input').val();

  var regel1 = $('.acf-field').find("[data-name='form3_regel1']").find(':input').val();
  var oplegreactie1 = $('.acf-field').find("[data-name='form3_oplegreactie1']").find(':input').val();
  var bloppervlak1 = $('.acf-field').find("[data-name='form3_bloppervlak1']").find(':input').val();

  var regel2 = $('.acf-field').find("[data-name='form3_regel2']").find(':input').val();
  var oplegreactie2 = $('.acf-field').find("[data-name='form3_oplegreactie2']").find(':input').val();
  var bloppervlak2 = $('.acf-field').find("[data-name='form3_bloppervlak2']").find(':input').val();

  var doorbuiging = $('.acf-field').find("[data-name='form3_doorbuiging']").find('label.selected > input[type="radio"]').val();

  $.ajax({
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'form3Calculate',
      hoogte: hoogte,
      breedte: breedte,
      aantal_regels: aantal_regels,
      kwaliteit: kwaliteit,
      stuwdruk: stuwdruk,
      zone: zone,
      overspanning: overspanning,
      belastinglinksonder: belastinglinksonder,
      belastingrechtsboven: belastingrechtsboven,
      regel1: regel1,
      oplegreactie1: oplegreactie1,
      bloppervlak1: bloppervlak1,
      regel2: regel2,
      oplegreactie2: oplegreactie2,
      bloppervlak2: bloppervlak2,
      doorbuiging: doorbuiging
    },
    method: 'POST',
    success: function (html) {
      $('.calculation-result').html(html);
      $('#form3Calc .acf-form-submit input[type="submit"]').prop("disabled", false).addClass('active');
    }
  });

}

$(document).ready(function(){

  $('.info-pin .acf-label').append('<div class="info"></div>');

  $('.info').click(function(){
    $('.info-box').addClass('active');
  });

  $('.info-box .close').click(function(){
    $('.info-box').removeClass('active');
  });

  $('#form3Calc .acf-form-submit input[type="submit"]').prop("disabled", true);
  $('#form3Calc .acf-form-submit').append('<input type="submit" id="calculate_form3" value="Berekenen" class="calculate-btn btn btn--primary"/>');

  $('#calculate_form3').click(function(e){
    e.preventDefault();
    calculateForm3();
  });

});



// WEBPACK FOOTER //
// ./resources/assets/js/form3.js